import request from "../utils/http.js";

// 样例
export const getname = () => {
  return request.get("/api/index/getname");
};
export const getWechatConfig = (url) => {
  return request.get("/getJssdk?url="+url);
};
